module.exports = __webpack_public_path__ + "img/discover.be8849aa.svg";